import { STORE_TABLE } from './type'
import * as tableAction from '../../../table/state/action'
import { selectOwnState, tableSelectorStore } from './selector'


export const initialTableQueryStore = tableAction.createInitialTableQueryAction(selectOwnState, STORE_TABLE)

export const changeFilterStore = tableAction.createChangeFilterAction(selectOwnState, STORE_TABLE)

export const toggleSortStore = tableAction.createToggleSortAction(selectOwnState, STORE_TABLE)

export const toggleMultiSortStore = tableAction.createToggleMultiSortAction(selectOwnState, STORE_TABLE)

export const gotoPageStore = tableAction.createGotoPageAction(STORE_TABLE)

export const initialTableSettings = tableAction.createInitialColumnsVisibilityTableHandler(STORE_TABLE)

export const toggleColumnVisibility = tableAction.createToggleColumnVisibilityTableHandler(tableSelectorStore, STORE_TABLE)





// WEBPACK FOOTER //
// ./src/modules/store/state/search/action.js